import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import classNames from 'classnames/bind';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { TOAST_BOTTOM_PADDING_BASE } from '../../constants/toast.js';
import styles from './ToastWrapper.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var hideElement = function hideElement(target, onDestroy) {
  target && target.addEventListener('transitionend', function () {
    onDestroy();
  });
};
function ToastWrapper(_ref) {
  var children = _ref.children,
    duration = _ref.duration,
    destroy = _ref.destroy,
    animation = _ref.animation,
    _ref$bottomPaddingBas = _ref.bottomPaddingBase,
    bottomPaddingBase = _ref$bottomPaddingBas === void 0 ? TOAST_BOTTOM_PADDING_BASE.BASIC : _ref$bottomPaddingBas,
    _ref$overTheDimmedLay = _ref.overTheDimmedLayer,
    overTheDimmedLayer = _ref$overTheDimmedLay === void 0 ? false : _ref$overTheDimmedLay;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    startTransform = _useState2[0],
    setStartTransform = _useState2[1];
  var $timeoutID = useRef(null);
  var $container = useRef(null);
  var handleDestroy = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if ($timeoutID.current) {
            clearTimeout($timeoutID.current);
            $timeoutID.current = null;
          }
          setStartTransform(false);
          hideElement($container.current, destroy);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [destroy]);
  useEffect(function () {
    setStartTransform(true);
    /**
     * duration < 0 : handleDestroy 실행 X (ToastAction은 auto-close하지 않음)
     * duration = 0 : handleDestroy 즉시 실행 (close)
     * duration > 0 : duration 밀리초 후 handleDestroy 실행 (ToastNotice)
     */
    if (duration >= 0) {
      $timeoutID.current = _setTimeout(handleDestroy, duration);
    }
    return function () {
      if ($timeoutID.current) {
        clearTimeout($timeoutID.current);
        $timeoutID.current = null;
      }
    };
  }, [duration, handleDestroy]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', animation, {
      'ani-active': startTransform
    }, "bottom-position-".concat(bottomPaddingBase), {
      'over-dimmed-layer': overTheDimmedLayer
    }),
    ref: $container
  }, children);
}

export { ToastWrapper as default };
